import React from 'react';
import { Routes, Route, useNavigate, useLocation } from 'react-router-dom';
import NavigationBar from './NavigationBar';
import ChoosePlan from './ChoosePlan';
import CreateAccount from './CreateAccount';
import SetupPayment from './SetupPayment';
import StartTraining from './StartTraining';
import PhoneVerification from './PhoneVerification';
import Dashboard from './Dashboard';
import Login from './Login';
import ForgotPassword from './ForgotPassword';
import Waitlist from './Waitlist';
import AdminAddLocation from './components/AdminAddLocation';
import PrivateRoute from './components/PrivateRoute';
import FAQ from './FAQ';
import HelpCenter from './HelpCenter';
import TermsOfUse from './TermsOfUse';
import LandingPage from './LandingPage';
import Privacy from './Privacy';
import CompanyPolicy from './CompanyPolicy';
import APIDocumentation from './components/APIDocumentation';
import EngineeringAndDataScience from './components/EngineeringAndDataScience';
import AccountManagement from './AccountManagement';
import PaymentIssues from './PaymentIssues';
import TechnicalSupport from './TechnicalSupport';
import SubscriptionPlans from './SubscriptionPlans';
import UsingCredits from './UsingCredits';
import ContactUs from './ContactUs';
import { useAuth } from './context/AuthContext';
import PreferencesPage from './PreferencesPage';
import UpdatePhonePage from './UpdatePhonePage';
import PaymentPage from './PaymentPage';
import ClasspassMapPage from './ClasspassMapPage';
import SessionDetailPage from './SessionDetailPage';

function App() {
    const { currentUser, logout } = useAuth();
    const navigate = useNavigate();
    const location = useLocation();

    const handleLogout = async () => {
        try {
            await logout();
            navigate('/login');
        } catch (error) {
            console.error('Failed to log out', error);
        }
    };

    // Determine if user is on waitlist page (special case - always show as logged out)
    const isWaitlistPage = location.pathname === '/waitlist';

    // Derive login state directly from auth context
    const isLoggedIn = !isWaitlistPage && !!currentUser;
    const showDashboardLink = isLoggedIn;

    return (
        <div style={{ height: '100%' }}>
            <NavigationBar
                isLoggedIn={isLoggedIn}
                showDashboardLink={showDashboardLink}
                handleLogout={handleLogout}
            />
            <Routes>
                <Route path="/choose-plan" element={<ChoosePlan />} />
                <Route path="/preferences/:phone" element={<PreferencesPage />} />
                <Route path="/create-account" element={<CreateAccount />} />
                <Route path="/setup-payment" element={<SetupPayment />} />
                <Route path="/phone-verification" element={<PhoneVerification />} />
                <Route path="/start-training" element={<StartTraining />} />
                <Route path="/dashboard" element={<PrivateRoute component={Dashboard} />} />
                <Route path="/login" element={<Login />} />
                <Route path="/forgot-password" element={<ForgotPassword />} />
                <Route path="/waitlist" element={<Waitlist />} />
                <Route path="/admin/add-location" element={<PrivateRoute component={AdminAddLocation} />} />
                <Route path="/api-documentation" element={<PrivateRoute component={APIDocumentation} />} />
                <Route path="/engineering" element={<EngineeringAndDataScience />} />
                <Route path="/faq" element={<FAQ />} />
                <Route path="/contact-us" element={<ContactUs />} />
                <Route path="/help-center" element={<HelpCenter />} />
                <Route path="/terms-of-use" element={<TermsOfUse />} />
                <Route path="/privacy" element={<Privacy />} />
                <Route path="/company-policy" element={<CompanyPolicy />} />
                <Route path="/account-management" element={<AccountManagement />} />
                <Route path="/payment-issues" element={<PaymentIssues />} />
                <Route path="/technical-support" element={<TechnicalSupport />} />
                <Route path="/subscription-plans" element={<SubscriptionPlans />} />
                <Route path="/using-credits" element={<UsingCredits />} />
                <Route path="/" element={<LandingPage />} />
                <Route path="/update-phone/:id" element={<UpdatePhonePage />} />
                <Route path="/payment" element={<PaymentPage />} />
                <Route path="/map" element={<ClasspassMapPage />} />
                <Route path="/session/:sessionId" element={<SessionDetailPage />} />
            </Routes>
        </div>
    );
}

export default App;